import { Zap, Globe, Layers, Cpu } from 'lucide-react';

export function About() {
    return (
        <div className="max-w-5xl mx-auto px-6 py-12 animate-in fade-in duration-500">
            <div className="text-center mb-20">
                <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
                    The Future of <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-purple-500">Digital Reading</span>
                </h1>
                <p className="text-xl text-slate-400 max-w-2xl mx-auto">
                    EMI is a universal interactive reader designed to transform static documents into living, breathing experiences.
                </p>
            </div>

            <div className="grid md:grid-cols-2 gap-12 mb-20">
                <div className="space-y-6">
                    <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center">
                        <Globe className="w-6 h-6 text-blue-500" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">Universal Accessibility</h3>
                    <p className="text-slate-300 leading-relaxed">
                        We believe information should be accessible anywhere, instantly. EMI cleans away the friction of downloads, logins, and incompatibilities. Just drag, drop, and read on any device.
                    </p>
                </div>
                <div className="space-y-6">
                    <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center">
                        <Zap className="w-6 h-6 text-purple-500" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">Zero-Latency Performance</h3>
                    <p className="text-slate-300 leading-relaxed">
                        Powered by Google's Firebase infrastructure with multi-region CDN replication, EMI delivers your content at edge speeds. Our custom Flipbook engine renders pages with WebGL acceleration for lag-free turning.
                    </p>
                </div>
                <div className="space-y-6">
                    <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center">
                        <Layers className="w-6 h-6 text-green-500" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">Immersion First</h3>
                    <p className="text-slate-300 leading-relaxed">
                        Reading is more than just data consumption. It's an experience. We simulate the tactile feel of paper with shadows, physics-based turning, and spatial audio to help you retain more of what you read.
                    </p>
                </div>
                <div className="space-y-6">
                    <div className="w-12 h-12 bg-orange-500/10 rounded-xl flex items-center justify-center">
                        <Cpu className="w-6 h-6 text-orange-500" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">Anonymous Identity</h3>
                    <p className="text-slate-300 leading-relaxed">
                        We pioneered the "Zero-Login" personal library. Utilizing cryptographic anonymous authentication, we provide you with a persistent, private space that feels personal without the data overhead.
                    </p>
                </div>
            </div>
        </div>
    );
}
